import { School } from './../../../models/school';
import { ExcelService } from './../../../services/excel.service';
import { NgxRolesService } from 'ngx-permissions';
import { AuthService } from './../../../services/auth.service';
import { Observable } from 'rxjs/Observable';
import { DataTablesResponse } from './../../../models/DataTablesResponse';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Passenger } from './../../../models/passenger';
import { Component, OnInit, OnDestroy, ViewChild, NgZone } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Select2OptionData } from 'ng2-select2';
import { Router, ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import { PNotifyService } from '../../../services/pnotify.service';
import { Journey } from './../../../models/journey';
const jsPDF = require('jspdf');
require('jspdf-autotable');
declare const google: any;


@Component({
  selector: 'app-passenger-datatable',
  templateUrl: './passenger-datatable.component.html',
  styleUrls: ['./passenger-datatable.component.css']
})
export class PassengerDatatableComponent implements OnInit, OnDestroy {

  isAssistant: boolean;
  routeBase: string;

  filter = {
    clientId: '',
    schoolId: '',
    busId: '',
    journeyId: '',
    name: '',
    inscriptionType: 'renew or -',
    isAssistant: false,
    isActive: true,
    isAdmin: false,
    isReserved: false,
  };
  staticFilter: any;
  public clientsData: Array<Select2OptionData>;
  public schoolsData: Array<Select2OptionData>;
  public busesData: Array<Select2OptionData>;
  public journeysData: Array<Select2OptionData>;
  adminStatus = true;

  @ViewChild(DataTableDirective)
  datatableElement: DataTableDirective;

  // ----- Start Option Scrollbar -----------
  isScrollbar: true;
  scrollbarOptions = {
    axis: 'y',
    theme: 'minimal-dark'
  };
  // ----- End Option Scrollbar -----------

  selectedAll = false;
  selectedMulti = false;

  dtOptions: any = {};
  dtCurrentpage: any;
  dtCurrentLen: any;
  dtIntiFlag: any;
  clients: any[];
  schools: any[];
  buses: any[];
  passengers: any[];
  journeys: any[];
  pnotify = undefined;
  isResponsible = false;
  directionsService: any;
  directionsRenderer: any;
  isReserved = false;
  enableCodesPDF = false;
  subscriptionOn: any = 0;
  stats = { withPosition: 0, withoutPosition: 0, total: 0 };

  // Bus assignment modal
  showAssignBusModal = false;
  assignPassengerId: any = null;
  assignPassengerName = '';
  assignBusId: any = '';
  assignBuses: any[] = [];
  assignLoading = false;
  isBulkAssign = false;
  assignPassengerIds: any[] = [];

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private roleService: NgxRolesService,
    private excelService: ExcelService,
    private router: Router,
    private route: ActivatedRoute,
    private zone: NgZone,
    pnotifyService: PNotifyService
  ) {
    this.isAssistant = false;
    this.routeBase = 'passenger';
    this.dtIntiFlag = false;
    this.route.params.subscribe(params => {
      this.dtCurrentpage = params['PgNo'];
      this.dtCurrentLen = params['PgLen'];
    });
    this.initClientSelect();
    this.pnotify = pnotifyService.getPNotify();
    if (this.roleService.getRole('ROLE_RESPONSIBLE')) {
      this.isResponsible = true;
    }
  }

   ngOnInit(): void {
    this.route.data
      .subscribe((data: { isAssistant: boolean }) => {
        this.routeBase = data.isAssistant ? 'assistant' : 'passenger';
        this.isAssistant = data.isAssistant;
        this.filter.isAssistant = data.isAssistant;
      });
    if (this.roleService.getRole('ROLE_ADMIN')) {
      this.filter.isAdmin = true; 
    }

    // Event lors de la fin d'init du dt
    $('table').on('init.dt', (event) => this.initPaginationTable());

    const columns = [
      { data: 'checkbox' },
      { data: 'busSchoolName' },
      { data: 'busName' },
      { data: 'lastname' },
      { data: 'firstnames' },
      // { data: 'count' }, nombre de passager
      { data: 'phone' },
      { data: 'subscription' },
      { data: 'positionStatus' },
      { data: 'activationKey' },
      //{ data: 'SmsToSend' },
      { data: 'actions' },
    ];
    if (this.isAssistant) {
      // columns.splice(7, 1);
      columns.splice(0, 1);
    }
    if (this.roleService.getRole('ROLE_ADMIN')) {
      columns.splice(1, 0, { data: 'clientName' }); 
    }
    
    this.dtOptions = {
      searching: false,
      pageLength: Number(this.dtCurrentLen),
      serverSide: true,
      processing: true,
      lengthMenu: [[5, 10, 25, 50, 100], [5, 10, 25, 50, 100]],
      order: [[1, 'asc']],
      ordering: false,
      columnDefs: [
        { 'orderable': false, 'targets': 0 }
      ],
      ajax: (dataTablesParameters: any, callback) => {
        dataTablesParameters.filter = this.staticFilter;
        this.http.post<DataTablesResponse>(
          '/api/passenger',
          dataTablesParameters,
          {}
        ).subscribe((resp: any) => {
          this.passengers = resp.data;
          let dta = [];
          this.passengers.forEach((passenger, index) => {
            const btnModifierETArchiver = `<a class="btn btnAction btnNavigate" data-url="/${this.routeBase}/edit/${passenger.id}">
                                  <i class="fa fa-pencil fa-2x" aria-hidden="true"></i>Modifier
                                </a>
                                <button class="btn btnAction btnArchive" data-passenger-id="${passenger.id}">
                                  <i class="fa fa-archive fa-2x" aria-hidden="true"></i>Archiver
                                </button>`;

            const btnRenew =  `<button class="btn btnAction btnRenew" data-passenger-id="${passenger.id}">
                                  <i class="fa fa-refresh fa-2x" aria-hidden="true"></i>Réinscrire
                                </button>`;

            const btnAssignBus = `<button class="btn btnAction btnAssignBus" data-passenger-id="${passenger.id}" data-passenger-name="${passenger.lastname}" data-bus-id="${passenger.busId}">
                                  <i class="fa fa-bus fa-2x" aria-hidden="true"></i>Bus
                                </button>`;

            const btnModifierETSupprimer = `<a class="btn btnAction btnNavigate" data-url="/${this.routeBase}/edit/${passenger.id}">
                                  <i class="fa fa-pencil fa-2x" aria-hidden="true"></i>Modifier
                                </a>
                                <button class="btn btnAction btnDelete" data-passenger-id="${passenger.id}">
                                  <i class="fa fa-trash fa-2x" aria-hidden="true"></i>Supprimer
                                </button>`;
            
            dta.push({
              id: passenger.id,
              checkbox: `<label class="el-switch" style="font-size:80%">
                          <input  type="checkbox"
                                  name="checkboxs[]"
                                  value="${passenger.id}"
                                  ${this.selectedAll ? 'checked' : ''}
                          >
                          <span class="el-switch-style"></span>
                        </label>`,
              busSchoolName: passenger.School ? passenger.School.name : '',
              busName: passenger.Bus ? passenger.Bus.name : '',
              lastname: passenger.lastname,
              firstnames: passenger.firstnames,
              // count: passenger.count,
              phone: passenger.phone,
              subscription: passenger.subscription,
              positionStatus: (passenger.isPositionValide ? `<label style="color:green">Définie</label>`
              : `<label style="color:red">Non définie</label>`),
              activationKey: passenger.activationKey,
              /*SmsToSend: passenger.SmsToSend == 0 ? `<label style="color:green">Envoyé</label>`
              : `<label style="color:orange">En-cours</label>`,*/
              actions: this.isAssistant ? `
                <a class="btn btnAction btnNavigate" data-url="/${this.routeBase}/view/${passenger.id}">
                  <i class="fa fa-search fa-2x" aria-hidden="true"></i>Détail
                </a>
                ${(this.adminStatus) ? btnModifierETSupprimer : ''}
                <!--<button class="btn btnAction btnCodeSMS" data-passenger-id="${passenger.id}">
                  <i class="fa fa-envelope fa-2x" aria-hidden="true"></i>Code par SMS
                </button> -->
              `
              : `
              <a class="btn btnAction btnNavigate" data-url="/${this.routeBase}/view/${passenger.id}">
                <i class="fa fa-search fa-2x" aria-hidden="true"></i>Détail
              </a>
              ${(this.adminStatus) ? btnModifierETArchiver : ''}
              ${btnAssignBus}
              <!--<button class="btn btnAction btnCodeSMS" data-passenger-id="${passenger.id}">
                <i class="fa fa-envelope fa-2x" aria-hidden="true"></i>Code par SMS
              </button> -->
              ${(this.subscriptionOn) ? btnRenew : ''}
            `
            });
            
            if (this.roleService.getRole('ROLE_ADMIN')) {
              dta[index].clientName = passenger.School.Client.name;
            }
          });

          if (resp.stats) {
            this.stats = {
              withPosition: resp.stats.withPosition || 0,
              withoutPosition: resp.stats.withoutPosition || 0,
              total: resp.stats.total || 0
            };
          }

          callback({
            recordsTotal: resp.recordsTotal,
            recordsFiltered: resp.recordsFiltered,
            data: dta
          });
        });
      },
      fnCreatedRow: function (nRow, aData, iDataIndex) {
        $(nRow).attr('id', 'passenger_' + aData.id);
      },
      columns: columns,
      dom: '<t> <"row" <"col-md-4"l><"col-md-8"p>>',
      language: {
        'sProcessing': 'Traitement en cours...',
        'sSearch': 'Rechercher&nbsp;:',
        'sLengthMenu': 'Afficher _MENU_ &eacute;l&eacute;ments',
        'sInfo': 'Affichage de l\'&eacute;l&eacute;ment _START_ &agrave; _END_ sur _TOTAL_ &eacute;l&eacute;ments',
        'sInfoEmpty': 'Affichage de l\'&eacute;l&eacute;ment 0 &agrave; 0 sur 0 &eacute;l&eacute;ment',
        'sInfoFiltered': '(filtr&eacute; de _MAX_ &eacute;l&eacute;ments au total)',
        'sInfoPostFix': '',
        'sLoadingRecords': 'Chargement en cours...',
        'sZeroRecords': 'Aucun &eacute;l&eacute;ment &agrave; afficher',
        'sEmptyTable': 'Aucune donn&eacute;e disponible dans le tableau',
        'oPaginate': {
          'sFirst': 'Premier',
          'sPrevious': 'Pr&eacute;c&eacute;dent',
          'sNext': 'Suivant',
          'sLast': 'Dernier'
        },
        'oAria': {
          'sSortAscending': ': activer pour trier la colonne par ordre croissant',
          'sSortDescending': ': activer pour trier la colonne par ordre d&eacute;croissant'
        }
      },
      // Use this attribute to enable the responsive extension
      responsive: true
    };
    /*$('table').on('click', '.btnCodeSMS', (event) => {
      this.onCodeSMS($(event.currentTarget).data('passengerId'));
    });*/
    $('table').on('click', '.btnDelete', (event) => {
      this.onDelete($(event.currentTarget).data('passengerId'));
    });
    $('table').on('click', '.btnArchive', (event) => {
      this.onArchive($(event.currentTarget).data('passengerId'));
    });
    $('table').on('click', '.btnRenew', (event) => {
      this.onNewSubscription($(event.currentTarget).data('passengerId'));
    });
    $('table').on('click', '.btnNavigate', (event) => {
      this.onNavigate($(event.currentTarget).data('url') + '/' + this.dtCurrentpage + '/' + this.dtCurrentLen);
    });
    $('table').on('click', '.btnAssignBus', (event) => {
      this.openAssignBusModal(
        $(event.currentTarget).data('passengerId'),
        $(event.currentTarget).data('passengerName'),
        $(event.currentTarget).data('busId')
      );
    });
    $('table').on('change', '[name="checkboxs[]"]', (event) => this.onCheckChange());

    $('table').on('draw.dt', (event) => this.onDtDrawChange());

  }

  ngOnDestroy(): void {
    $.fn['dataTable'].ext.search.pop();
    $('table').off();
  }

  initPaginationTable(): void {
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      const pgsInfo = dtInstance.page.info();
      const totalPg = pgsInfo.pages;
      let pgNo  = 0;

      if (this.dtCurrentpage === 'last' ) {
        pgNo = totalPg - 1;
      } else {
        pgNo = Number(this.dtCurrentpage);
      }
      // dtInstance.page.len(Number(this.dtCurrentLen));
      dtInstance.page(pgNo);
      dtInstance.draw(false);
      this.dtIntiFlag = true;
   });
  }

  updatePaginationInfo(): void {
    if (this.dtIntiFlag === true) {
      this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
        const pgsInfo = dtInstance.page.info();
        this.dtCurrentpage = pgsInfo.page;
        this.dtCurrentLen = pgsInfo.length;
     });
    }
  }

  initClientSelect() {
    if (this.roleService.getRole('ROLE_CLIENT') || this.roleService.getRole('ROLE_SUPER_CLIENT')) {
      const client = this.authService.getUser();
      this.clients = [{ id: client.id, name: client.name }];
      this.filter.clientId = client.id;
      this.initSchoolSelect();
    } else if (this.roleService.getRole('ROLE_RESPONSIBLE')) {
      const client = this.authService.getUser().School.Client;
      this.clients = [{ id: client.id, name: client.name }];
      this.filter.clientId = client.id;
      this.adminStatus = this.authService.getUser().isRespAdmin;
      this.initSchoolSelect();
    } else {
      this.http.get(
        '/api/client/lookup'
      ).subscribe((clients: any[]) => {
        this.clients = clients;
        const array1 = [{ id: '', text: 'Choisir un client' }];
        const array2 = this.clients.map(function (client, index) {
          return { id: client.id, text: client.name };
        });
        this.clientsData = array1.concat(array2);
        // this.initSchoolSelect();
      });
    }
    this.staticFilter = this.filter;
  }

  clientChanged(e: any) {
    this.filter.clientId = e.value;
    this.initSchoolSelect();
  }

  initSchoolSelect() {
    this.filter.schoolId = '';
    let params = new HttpParams({
      fromObject: {
        clientId: this.filter.clientId
      }
    });
    this.http.get(
      '/api/school/lookup',
      { params }
    ).subscribe((schools: any[]) => {
      this.schools = schools;
      // Check subscription only when client mode
      if (this.schools.length === 1 && (this.roleService.getRole('ROLE_CLIENT') || this.roleService.getRole('ROLE_SUPER_CLIENT'))) {
        this.subscriptionOn  = this.schools[0].subscriptionOn;
      } 
      const array1 = [{ id: '', text: 'Choisir une option' }];
      const array2 = this.schools.map((school, index) => {
        if (this.roleService.getRole('ROLE_RESPONSIBLE')) {
          return {
            id: school.id,
            text: school.name,
            selected: (this.authService.getUser().School.id === school.id) ? true : false
          };
        } else {
          return { id: school.id, text: school.name };
        }
      });
      this.schoolsData = array1.concat(array2);
      this.busesData = [{ id: '', text: 'Choisir une option' }];
      // this.initBusSelect();
    });
  }
  schoolChanged(e: any) {
    this.filter.schoolId = e.value;
    this.initBusSelect();
  }

  initBusSelect() {
    this.filter.busId = '';
    let params = new HttpParams({
      fromObject: {
        clientId: this.filter.clientId,
        schoolId: this.filter.schoolId
      }
    });
    this.http.get(
      '/api/bus/lookup',
      { params }
    ).subscribe((buses: any[]) => {
      this.buses = buses;
      const array1 = [{ id: '', text: 'Choisir une option' }];
      const array2 = this.buses.map(function (bus, index) {
        return { id: bus.id, text: bus.name };
      });
      this.busesData = array1.concat(array2);
    });
  }

  busChanged(e: any) {
    this.filter.busId = e.value;
    this.initJourneySelect();
    if (e.value > 0) {
      this.enableCodesPDF = true;
    } else {
      this.enableCodesPDF = false;
    }
  }

  initJourneySelect() {
    this.filter.journeyId = '';
    const params = new HttpParams({
      fromObject: {
        clientId: this.filter.clientId,
        schoolId: this.filter.schoolId,
        busId: this.filter.busId
      }
    });
    this.http.get(
      '/api/journey/lookup',
      { params }
    ).subscribe((journeys: any[]) => {
      this.journeys = journeys;
      const array1 = [{ id: '', text: 'Choisir une trajet' }];
      const array2 = this.journeys.map(function (journey, index) {
        return { id: journey.id, text: journey.name };
      });
      this.journeysData = array1.concat(array2);
    });
  }

  journeyChanged(e: any) {
    this.filter.journeyId = e.value;
  }

  onSelectedAllChange() {
    $('[name="checkboxs[]"]').prop('checked', this.selectedAll);
    this.onCheckChange();
  }

  onCheckChange() {
    const length = $('[name="checkboxs[]"]:checked').length;
    if (length > 1 && !this.isAssistant) {
      this.selectedMulti = true;
    } else {
      this.selectedMulti = false;
    }
  }

  onDtDrawChange() {
    this.onCheckChange();
    this.updatePaginationInfo();
  }

  onNavigate(url) {
    this.zone.run(() => this.router.navigateByUrl(url));
  }

  openAssignBusModal(passengerId: any, passengerName: string, currentBusId?: any) {
    this.isBulkAssign = false;
    this.assignPassengerIds = [];
    this.assignPassengerId = passengerId;
    this.assignPassengerName = passengerName || 'ce passager';
    // Preselect the current bus (ignore '0', 'null', '' sentinel values)
    this.assignBusId = (currentBusId && currentBusId !== '0' && currentBusId !== 'null') ? currentBusId : '';
    this.assignLoading = false;
    this.showAssignBusModal = true;

    // Load buses for the current filter's school (already loaded by the filter)
    if (this.buses && this.buses.length > 0) {
      this.assignBuses = this.buses;
    } else {
      // Fallback: fetch buses for the filter school
      const params = new HttpParams({
        fromObject: {
          clientId: this.filter.clientId,
          schoolId: this.filter.schoolId
        }
      });
      this.http.get('/api/bus/lookup', { params }).subscribe((buses: any[]) => {
        this.assignBuses = buses;
      });
    }
  }

  openBulkAssignBusModal() {
    const ids: any[] = [];
    $('[name="checkboxs[]"]:checked').each((i, elt: any) => {
      ids.push($(elt).val());
    });
    if (ids.length === 0) return;

    this.isBulkAssign = true;
    this.assignPassengerIds = ids;
    this.assignPassengerId = null;
    this.assignPassengerName = ids.length + ' passager(s) sélectionné(s)';
    this.assignBusId = '';
    this.assignLoading = false;
    this.showAssignBusModal = true;

    if (this.buses && this.buses.length > 0) {
      this.assignBuses = this.buses;
    } else {
      const params = new HttpParams({
        fromObject: {
          clientId: this.filter.clientId,
          schoolId: this.filter.schoolId
        }
      });
      this.http.get('/api/bus/lookup', { params }).subscribe((buses: any[]) => {
        this.assignBuses = buses;
      });
    }
  }

  closeAssignBusModal() {
    this.showAssignBusModal = false;
    this.assignPassengerId = null;
    this.assignPassengerName = '';
    this.assignBusId = '';
    this.assignBuses = [];
    this.isBulkAssign = false;
    this.assignPassengerIds = [];
  }

  executeAssignBus() {
    if (this.assignLoading) return;
    if (!this.isBulkAssign && !this.assignPassengerId) return;
    if (this.isBulkAssign && this.assignPassengerIds.length === 0) return;
    this.assignLoading = true;

    const busId = this.assignBusId || 'null';
    const idsToAssign = this.isBulkAssign ? this.assignPassengerIds : [this.assignPassengerId];

    const requests = idsToAssign.map(id =>
      this.http.put(`/api/passenger/assign/${id}/${busId}`, {}).toPromise()
    );

    Promise.all(requests)
      .then(() => {
        this.assignLoading = false;
        this.closeAssignBusModal();
        if (this.pnotify) {
          this.pnotify.success({ title: 'Succès', text: 'Affectation du bus mise à jour.' });
        }
        this.selectedMulti = false;
        this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.draw(false);
        });
      })
      .catch(() => {
        this.assignLoading = false;
        if (this.pnotify) {
          this.pnotify.error({ title: 'Erreur', text: 'Impossible de changer le bus.' });
        }
      });
  }

  onDelete(id) {
    this.pnotify.notice({
      title: 'Confirmation',
      text: 'Voulez-vous supprimer cet element ?',
      stack: {
        firstpos1: 70, firstpos2: 10,
        modal: true,
        overlay_close: true
      },
      hide: false,
      modules: {
        Confirm: {
          confirm: true,
          buttons: [
            {
              text: 'Ok',
              addClass: 'btn btn-chico',
              click: notice => {
                this.delete(id);
                notice.close();
              }
            },
            {
              text: 'Annuler',
              addClass: 'btn btn-default',
              click: (notice) => {
                notice.close();
                notice.fire('pnotify.cancel', { notice });
              }
            }
          ]
        }
      }
    });
  }

  onArchive(id) {
    this.pnotify.notice({
      title: 'Confirmation',
      text: 'Ce passager sera dissocié de tous ces trajets. Voulez-vous archiver cet element ?',
      stack: {
        firstpos1: 70, firstpos2: 10,
        modal: true,
        overlay_close: true
      },
      hide: false,
      modules: {
        Confirm: {
          confirm: true,
          buttons: [
            {
              text: 'Ok',
              addClass: 'btn btn-chico',
              click: notice => {
                this.archive(id);
                notice.close();
              }
            },
            {
              text: 'Annuler',
              addClass: 'btn btn-default',
              click: (notice) => {
                notice.close();
                notice.fire('pnotify.cancel', { notice });
              }
            }
          ]
        }
      }
    });
  }

  onBulkArchive() {
    this.pnotify.notice({
      title: 'Confirmation',
      text: 'Voulez-vous archiver la selection ?',
      stack: {
        firstpos1: 70, firstpos2: 10,
        modal: true,
        overlay_close: true
      },
      hide: false,
      modules: {
        Confirm: {
          confirm: true,
          buttons: [
            {
              text: 'Ok',
              addClass: 'btn btn-chico',
              click: notice => {
                $('[name="checkboxs[]"]:checked').each((i, elt: any) => {
                  this.archive($(elt).val());
                });
                this.selectedMulti = false;
                notice.close();
              }
            },
            {
              text: 'Annuler',
              addClass: 'btn btn-default',
              click: (notice) => {
                notice.close();
                notice.fire('pnotify.cancel', { notice });
              }
            }
          ]
        }
      }
    });
  }

  onBulkSubscription() {
    this.pnotify.notice({
      title: 'Confirmation',
      text: 'Voulez-vous inscrire la selection dans la prochaine rentrée scolaire ?',
      stack: {
        firstpos1: 70, firstpos2: 10,
        modal: true,
        overlay_close: true
      },
      hide: false,
      modules: {
        Confirm: {
          confirm: true,
          buttons: [
            {
              text: 'Ok',
              addClass: 'btn btn-chico',
              click: notice => {
                $('[name="checkboxs[]"]:checked').each((i, elt: any) => {
                  this.newSubscribe($(elt).val());
                });

                // Uncheck all checkboxes
                $('[name="checkboxs[]"]:checked').prop('checked', false);

                this.selectedMulti = false;
                notice.close();
              }
            },
            {
              text: 'Annuler',
              addClass: 'btn btn-default',
              click: (notice) => {
                notice.close();
                notice.fire('pnotify.cancel', { notice });
              }
            }
          ]
        }
      }
    });
  }

  archive(id) {
    let selectedpassenger;
    this.passengers.forEach((passenger) => {
      if (id == passenger.id){
        selectedpassenger = passenger;
        selectedpassenger.isActive = 0;
      }
    });
    this.http
      .put(
        '/api/passenger/archive/' + id,
        { passenger: selectedpassenger }
      )
      .subscribe(
        (resp: any)  => {
          this.updateAffectedjourneys(resp.AffectedJourneyIds);
          document.getElementById('passenger_' + id).remove();
        },
        error => {
          this.pnotify.error({
            title: 'Erreur',
            text: 'Une erreur est survenue !',
            stack: {
              firstpos1: 70, firstpos2: 10,
              modal: true,
              overlay_close: true
            },
            hide: false,
            modules: {
              Confirm: {
                confirm: true,
                buttons: [
                  {
                    text: 'Ok',
                    addClass: 'btn btn-chico',
                    click: notice => {
                      notice.close();
                    }
                  }
                ]
              }
            }
          });
        }
      );
  }

  onNewSubscription(id){
    this.pnotify.notice({
      title: 'Confirmation',
      text: 'Voulez-vous inscrire la selection dans la prochaine rentrée scolaire ?',
      stack: {
        firstpos1: 70, firstpos2: 10,
        modal: true,
        overlay_close: true
      },
      hide: false,
      modules: {
        Confirm: {
          confirm: true,
          buttons: [
            {
              text: 'Ok',
              addClass: 'btn btn-chico',
              click: notice => {
                this. newSubscribe(id);
                notice.close();
              }
            },
            {
              text: 'Annuler',
              addClass: 'btn btn-default',
              click: (notice) => {
                notice.close();
                notice.fire('pnotify.cancel', { notice });
              }
            }
          ]
        }
      }
    });
  }

  newSubscribe(id) {
    let selectedpassenger;
    this.passengers.forEach((passenger) => {
      if (id == passenger.id){
        selectedpassenger = passenger;
        selectedpassenger.inscriptionStatus = selectedpassenger.isPositionValide ? 'Attente' : 'PNV';// check if position is nok to set position NOK
        selectedpassenger.inscriptionType = 'renew';
        selectedpassenger.inscriptionDate = moment().format('YYYY-MM-DD'); // today inscription
      }
    });
    this.http
      .put(
        '/api/passenger/' + id,
        { passenger: selectedpassenger }
      )
      .subscribe(
        result => {
          //this.inscriptionTypeSelected = '' ;
        }
      );
  }

  updateAffectedjourneys(AffectedJourneyIds: any) {
    let journey: any;
    let results: any;

    for (let i = 0; i < AffectedJourneyIds.length; i++) {
      this.http.get(
        '/api/journey/findOne/' + AffectedJourneyIds[i]
      ).subscribe((_journey: Journey) => {
        journey = _journey;

        results = this.calculateNewRoute(journey);
      });
    }
  }

  calculateNewRoute(_journey: Journey) {
    const journey: Journey = _journey;
    this.directionsService = new google.maps.DirectionsService;
    this.directionsRenderer = new google.maps.DirectionsRenderer({ suppressMarkers: true });
    const waypts = [];
    let PositionPassager: any;

    journey.start = new Date(Number(_journey.start) * 1000);
    journey.JourneyPassengers.forEach((JourneyPassenger) => {
      PositionPassager = new google.maps.LatLng(Number(JourneyPassenger.Passenger.lat), Number(JourneyPassenger.Passenger.lng));
      waypts.push({
        location: PositionPassager,
        stopover: true
      });
    });

    this.directionsService.route({
      origin: { lat: Number(journey.startPositionLat), lng: Number(journey.startPositionLng) },
      destination: { lat: Number(journey.endPositionLat), lng: Number(journey.endPositionLng) },
      waypoints: waypts,
      optimizeWaypoints: true,
      travelMode: 'DRIVING'
    }, (response, status) => {
      let distancetrajet: any = 0;
      let TimeEstimatedPassager: any = this.getElapsedSecondsInDay(journey.start);
      if (journey.type === ('M1' || 'AM1')) {
        journey.waitTimePassager = 20;
      } else {
        journey.waitTimePassager = 0;
      }
      if (status === 'OK') {
        // this.directionsRenderer.setDirections(response);
        // Calcule: Temps estimé de fin de trajet / Arrivé a chaque arret / distance total estimé
        if (waypts.length > 0) {
          const route = response.routes[0];
          // 1- Ajouter la distance et la durée du point depart au premier passager
          distancetrajet = distancetrajet + route.legs[0].distance.value;
          TimeEstimatedPassager = TimeEstimatedPassager + route.legs[0].duration.value;
          journey.JourneyPassengers[0].estimatedTime = new Date(Number(TimeEstimatedPassager) * 1000);
          // 2- Ajouter la distance et la durée pour chaque point d'arret
          for (let i = 1; i <= route.legs.length - 2; i++) {
            distancetrajet = distancetrajet + route.legs[i].distance.value;
            TimeEstimatedPassager = TimeEstimatedPassager + route.legs[i].duration.value + journey.waitTimePassager;
            journey.JourneyPassengers[i].estimatedTime = new Date(Number(TimeEstimatedPassager) * 1000);
          }
          // 3- Ajouter la distance et la durée pour aller au point destinations
          distancetrajet = distancetrajet + route.legs[route.legs.length - 1].distance.value;
          TimeEstimatedPassager = TimeEstimatedPassager + route.legs[route.legs.length - 1].duration.value;

          journey.distance = Number((distancetrajet / 1000).toFixed(0));
          journey.end = new Date(Number(TimeEstimatedPassager) * 1000);

        }
        journey.start = this.getElapsedSecondsInDay(journey.start);
        journey.end = this.getElapsedSecondsInDay(journey.end);
        journey.JourneyPassengers.forEach((journeyPassenger, index) => {
          journey.JourneyPassengers[index].estimatedTime = this.getElapsedSecondsInDay(journeyPassenger.estimatedTime);
          journeyPassenger.order = index + 1;
        });
        // Update server
        this.http.put(
          '/api/journey/' + journey.id,
          { journey: journey }
        ).subscribe(() => {},
          (error) => {
            this.pnotify.error({
              title: 'Erreur',
              text: 'Une erreur est survenue !',
              stack: {
                firstpos1: 70, firstpos2: 10,
                modal: true,
                overlay_close: true
              },
              hide: false,
              modules: {
                Confirm: {
                  confirm: true,
                  buttons: [
                    {
                      text: 'Ok',
                      addClass: 'btn btn-chico',
                      click: notice => {
                        notice.close();
                      }
                    }
                  ]
                }
              }
            });
          }
        );
      } else {
        console.log ('Directions request failed due to ' + status);
      }
    });
  }

  getElapsedSecondsInDay(date) {
    const day = moment(date);
    const startOfDay = day.clone().startOf('day');
    return day.diff(startOfDay, 'seconds');
  }

  onCodeSMS(id){
    let selectedpassenger;
    this.passengers.forEach((passenger) => {
      if (id == passenger.id){
        selectedpassenger = passenger;
        selectedpassenger.SmsToSend = 1;
        // window.alert(selectedpassenger.lastname + ' ' + selectedpassenger.SmsToSend);
      }
    });

    this.http.put(
        '/api/passenger/' + id,
        { passenger: selectedpassenger }
      ).subscribe();
      this.pnotify.notice({
      title: 'Information',
      text: 'La demande d\'envoie SMS est enregirstré',
      stack: {
        firstpos1: 70, firstpos2: 10,
        modal: true,
        overlay_close: true
      },
      hide: false,
      modules: {
        Confirm: {
          confirm: true,
          buttons: [
            {
              text: 'Ok',
              addClass: 'btn btn-chico',
              click: (notice) => {
                notice.close();
                notice.fire('pnotify.cancel', { notice });
              }
            }
          ]
        }
      }
    });
  }

  onBulkDelete() {
    this.pnotify.notice({
      title: 'Confirmation',
      text: 'Voulez-vous supprimer la selection ?',
      stack: {
        firstpos1: 70, firstpos2: 10,
        modal: true,
        overlay_close: true
      },
      hide: false,
      modules: {
        Confirm: {
          confirm: true,
          buttons: [
            {
              text: 'Ok',
              addClass: 'btn btn-chico',
              click: notice => {
                $('[name="checkboxs[]"]:checked').each((i, elt: any) => {
                  this.delete($(elt).val());
                });
                this.selectedMulti = false;
                notice.close();
              }
            },
            {
              text: 'Annuler',
              addClass: 'btn btn-default',
              click: (notice) => {
                notice.close();
                notice.fire('pnotify.cancel', { notice });
              }
            }
          ]
        }
      }
    });
  }

  delete(id) {
    this.http
      .delete('/api/passenger/' + id)
      .subscribe(
        result => {
          document.getElementById('passenger_' + id).remove();
        },
        error => {
          this.pnotify.error({
            title: 'Erreur',
            text: 'Une erreur est survenue !',
            stack: {
              firstpos1: 70, firstpos2: 10,
              modal: true,
              overlay_close: true
            },
            hide: false,
            modules: {
              Confirm: {
                confirm: true,
                buttons: [
                  {
                    text: 'Ok',
                    addClass: 'btn btn-chico',
                    click: notice => {
                      notice.close();
                    }
                  }
                ]
              }
            }
          });
        }
      );
  }

  onFilter(): void {
    this.filter.isReserved = this.isReserved;
    this.staticFilter = this.filter;
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
       dtInstance.draw();
    });
  }

  onExport() {
    this.http.post(
      '/api/passenger',
      { filter: this.staticFilter }
    ).subscribe((resp: any) => {
      
      console.log("resp",resp);

      const stopOrder = [
        [
          'vehicle-id',
          'stop-id',
        ]
      ];

      const stops = [
        [
          'id',
          'job-id',
          'type',
          'name',
          'address',
          'latitude',
          'longitude',
          'service-duration',
          'start-time',
          'end-time',
          'quantity',
        ]
      ];
      for (let i = 0; i < resp.data.length; i++) {
        stops.push([
          'ID' + resp.data[i].id,
          '',
          'P',
          resp.data[i].lastname + ' ' + resp.data[i].firstnames,
          resp.data[i].phone,
          resp.data[i].lat,
          resp.data[i].lng,
          '00:00:45',
          resp.data[i].estimatedDepartureTime,
          resp.data[i].estimatedArrivalTime,
          resp.data[i].count,
        ]);
      }
      const vehicleTypes = [
        [
          'vehicle-name',
          'vehicle-id',
          'start-latitude',
          'start-longitude',
          'end-latitude',
          'end-longitude',
          'start-time',
          'end-time',
          'capacity',
          'number-of-vehicles',

        ]
      ];
      const arrBusIds = [];
      for (let i = 0; i < resp.data.length; i++) {
        if (resp.data[i].hasOwnProperty('Bus') && resp.data[i].Bus !== null) {
          if (!arrBusIds.includes(resp.data[i].Bus.id)) {
            vehicleTypes.push([
              resp.data[i].Bus.name,
              resp.data[i].Bus.id,
              resp.data[i].School.lat,
              resp.data[i].School.lng,
              resp.data[i].School.lat,
              resp.data[i].School.lng,
              '',
              '',
              resp.data[i].Bus.maxLoad,
              '1',
            ]);
            arrBusIds.push(resp.data[i].Bus.id);
          }
        }
      }

      this.excelService.exportAsExcelFileWithMultiplePage([
        {
          name: 'Stop-order',
          data: stopOrder
        },
        {
          name: 'Stop',
          data: stops
        },
        {
          name: 'VehiculeTypes',
          data: vehicleTypes
        }], 'Rapport');
    });
  }

  onPassengerExportPerSchool() {
    this.http.post(
      '/api/passenger',
      { filter: this.staticFilter }
    ).subscribe((resp: any) => {

      const passagers = [
        [
          'id',
          'code',
          'bus',
          'matricule',
          'lastname',
          'firstnames',
          'phone',
          'subscription',
          'position',
          'information'
        ]
      ];

      for (let i = 0; i < resp.data.length; i++) {

        // Splitting first names by '/'
        const firstNames = resp.data[i].firstnames.split('/');
        const registrationNumbers = resp.data[i].registrationNumbers.split('/');

        // Pushing each first name separately into the body array
        firstNames.forEach((firstName, j) => { // <-- 'j' will be automatically incremented for each iteration
          
          passagers.push([
            resp.data[i].id,
            resp.data[i].activationKey,
            resp.data[i].Bus ? resp.data[i].Bus.name : '',
            registrationNumbers[j],
            resp.data[i].lastname,
            firstName,
            resp.data[i].phone,
            resp.data[i].subscription,
            (resp.data[i].isPositionValide === 1) ? 'yes' : 'no',
            resp.data[i].address,
          ]);

      });
        
        
      }

      let fileName, sheetName = '';

      if (resp.data[0].School.name) {
        fileName = 'Liste Parents' + resp.data[0].School.name;
      } else {
        fileName = 'Liste Parents ';
      }
      
      const currentDate = new Date();
      const day = String(currentDate.getDate()).padStart(2, '0');
      const month = String(currentDate.getMonth() + 1).padStart(2, '0');
      const year = currentDate.getFullYear();

      fileName = `${fileName} ${day}-${month}-${year}`;
      
      sheetName = `${day}-${month}-${year}`;

      this.excelService.exportAsExcelFileWithMultiplePage([
        {
          name: sheetName,
          data: passagers
        },
        ], fileName);

    });

  }

  onPassengerExportPerBus() {
    
    const doc = new jsPDF();
    doc.setFontSize(20);
    doc.setFont('', 'bold');
    const body = [];
    const msg = ('Votre code est : ');
    let selectedBus:any;
    let params = new HttpParams({
      fromObject: {
        busId: this.filter.busId
      }
    });
    this.http.get(
      '/api/bus/lookup',
      { params }
    ).subscribe((bus: any) => {
      selectedBus = bus;
      console.log(bus);
      doc.text(15, 20, 'Reference de bus: ' + bus[0].name );
    });

    
    // selectione les Ids a prendre en compte
    const selectedIds = [];
    $('[name="checkboxs[]"]:checked').each((i, elt: any) => {
      selectedIds.push($(elt).val());
    });
    this.selectedMulti = false;

    let passengers = [];
    const busIds: any[] = [];
    //window.alert(this.filter.busId);
    busIds.push(this.filter.busId);
    
    // get date on string for pdf title
    let today = new Date();
    const offset = today.getTimezoneOffset();
    today = new Date(today.getTime() - (offset*60*1000));
    let todayString = today.toISOString().split('T')[0];
    params = new HttpParams({
      fromObject: {
        busIds: JSON.stringify(busIds),
        isAssistant: 'false',
        isActive: 'true',
        isReserved: (this.isReserved) ? 'true': 'false'
      }
    });
    console.log(this.isReserved);
    console.log(params);
    this.http.get(
      '/api/passenger/lookup',
      { params }
    ).subscribe((data: any) => {
      passengers = data.rows.map((passenger) => {
       //window.alert(passenger.lastname);
        return {
          id: passenger.id,
          lastname: passenger.lastname,
          firstnames: passenger.firstnames,
          activationKey: passenger.activationKey,
        };
      });
      //window.alert(selectedIds);
      //console.log(selectedIds);
      passengers.forEach(passenger => {
        selectedIds.forEach(selectedId => {
          // console.log(parseInt(selectedId), passenger.id );
          if(parseInt(selectedId) === passenger.id) {
            body.push([
              passenger.lastname,
              passenger.firstnames,
              passenger.activationKey,
              msg + passenger.activationKey
            ]);
          }
        });
      });
      doc.autoTable({
        startY: 30,
        theme: 'striped',
        headStyles: {
          fillColor: '#000',
          textColor: '#fff'
        },
        head: [['nom', 'prénom', 'code','instruction']],
        body: body
      });
      //doc.addPage();
   
    doc.save('passager_'+selectedBus[0].name+'_'+todayString+'.pdf');
    });
    /*
    this.http
      .get('/api/journey/bus/' + busId)
      .subscribe((journeys: any[]) => {
        const doc = new jsPDF();
        journeys.forEach((journey) => {
          doc.setFontSize(20);
          doc.setFont('', 'bold');
          doc.text(15, 20, journey.Bus.School.name + ': ' + journey.Bus.name);
          const body = [];
          const msg = ('votre code est : ');
          journey.JourneyPassengers.forEach(journeyPassenger => {
            body.push([
              journeyPassenger.Passenger.lastname,
              journeyPassenger.Passenger.firstnames,
              journeyPassenger.Passenger.activationKey,
              msg + journeyPassenger.Passenger.activationKey
            ]);
          });
          doc.autoTable({
            startY: 30,
            theme: 'striped',
            headStyles: {
              fillColor: '#000',
              textColor: '#fff'
            },
            head: [['nom', 'prénom', 'code','instruction']],
            body: body
          });
          doc.addPage();
        });
        doc.save('passager.pdf');
      });
      */
  }

}



// WEBPACK FOOTER //
// ./src/app/components/passenger/passenger-datatable/passenger-datatable.component.ts